import { render, staticRenderFns } from "./_customize_sports_order.vue?vue&type=template&id=4d320553&lang=pug&"
import script from "./_customize_sports_order.vue?vue&type=script&lang=js&"
export * from "./_customize_sports_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports